<template>
<div class="basket-cntor">
    <div class="cntor-wrapper">
        <div class="total">
            <div class="check-box" 
            @click="isChecked = !isChecked;$emit('basketPickAll',isChecked);"
            :class ="{'act' : isChecked && basket_list.length}"
            ></div>
            <p>全选</p>
        </div>

        <div class="cost-info">
            <div>合计 <em class="icon-m3b"></em> <span class="cost">{{ sum.now - sum.cut - sum.offer}}</span><div class="u-btn reflash" @click="basketRender()"></div></div>
            <p>优惠已减<span class="discount">{{ sum.total - sum.now + sum.cut + sum.offer}}</span><em class="u-btn sale-detail" @click="callSaleModal();">优惠明细</em></p>
        </div>

        <div class="u-btn primary" @click="callBuyModal();"></div>
    </div>  
</div>
</template>

<script>
export default {
    data (){
        return {
            sum : {
                total : 0,
                now : 0,
                cut : 0,
                offer : 0,
            },
            isChecked : false,
            list : () => {},
        }
    },
    watch : {
        basket_list :{
            handler(val, oldVal){
            var flag = !val.filter(function(e){
                return e.isChecked == false;
            }).length;

            this.isChecked = flag;
            this.calculate();
            },
            deep:true //true 深度监听
        }
    },
    props : {
        basket_list : {
            default : [],
        },
        shop_offer :{
            default : () => {},
        },
        m3b :{
            default : 0,
        }         
    },
    methods : {
        basketRender (){},
        callSaleModal (){
            let pick_list = [];
            this.list.forEach(shop => {
                shop.data.forEach(item => {
                    pick_list.push(item.id)
                })            
            });
            
            if(!pick_list.length)return this.$toast('还没有选购任何商品~');

            this.$axios.post(this.$ajax_url_map.settle,this.$qs.stringify({
                ids: pick_list,
                preview: 1                
            }))
            .then(res => {
                this.$sale_detail({
                    settle : res.data,
                });
            },rej => {
                return this.$toast(rej.message);
            })
        },
        basketListSort(arr) {
            var map = {},
                dest = [];
            for (var i = 0; i < arr.length; i++) {
                var ai = arr[i];
                if (!map[ai.discountType]) {
                    dest.push({
                        discountName: ai.discountName,
                        discountType: ai.discountType,
                        shopOfferType : ai.shopOfferType,
                        data: [ai],                        
                    });
                    map[ai.discountType] = ai;
                } else {
                    for (var j = 0; j < dest.length; j++) {
                        var dj = dest[j];
                        if (dj.discountType == ai.discountType) {
                            dj.data.push(ai);
                            break;
                        }
                    }
                }
            }
            return dest;
        },        
        callBuyModal (){
            let _this = this;
            let pick_list = [],
                buy_detail_list = [];
            this.list.forEach(shop => {
                shop.data.forEach(item => {
                    pick_list.push(item.id)
                    buy_detail_list.push(item)
                })            
            });
            
            if(!pick_list.length)return this.$toast('还没有选购任何商品~');

            this.$axios.post(this.$ajax_url_map.settle,this.$qs.stringify({
                ids: pick_list,               
            }))
            .then(res => {
                this.$emit('call_buyModal',{
                    settle : res.data,
                    list : buy_detail_list,
                    m3b : _this.m3b,
                })
            },rej => {
                return this.$toast(rej.message);
            })            
        },
        calculate (arr){
            var _this = this;
            _this.sum = {
                total : 0,
                now : 0,
                cut : 0,
                offer : 0,
            }

            var temp_list = [];
            
            this.basket_list.forEach(shop => {
                var temp_total = 0;

                if(shop.isChecked){
                    shop.data.forEach(item => {
                        _this.sum.total += item.priceBefore
                        _this.sum.now += item.priceCurrent
                        temp_total += item.priceCurrent
                        temp_list.push(item)
                    })
                }
                else{
                    shop.data.forEach(item => {
                        if(item.isChecked){
                            _this.sum.total += item.priceBefore
                            _this.sum.now += item.priceCurrent
                            temp_total += item.priceCurrent
                            temp_list.push(item)
                        }
                    })                    
                }

                //优惠券
                let shopOfferType = _this.shop_offer.filter(function(e){ return e.shopId == shop.shopId }),
                    shopOfferDetail = null;
                if(shopOfferType.length){
                    shopOfferDetail = shopOfferType[0].state == 1 ? _this.$global.shopOfferType[shopOfferType[0].shopOfferType] : null;
                }
                if(shopOfferDetail){
                    let require_cost = shopOfferDetail.require;
                    if(temp_total >= require_cost){
                        _this.sum.offer += Math.min(shopOfferDetail.max,Math.floor( temp_total * (10 - shopOfferDetail.rate*10)/10 ));
                    }
                }
            });

            //跨店满减
            _this.list = _this.basketListSort(temp_list);
            _this.list.forEach(shop => {
                let discountType = _this.$global.discountType[shop.discountType],
                    _total = 0;

                shop.data.forEach(item => {
                    _total += item.priceCurrent;
                })

                _this.sum.cut += discountType.cut * parseInt(_total/discountType.parse);
            })

        },
    }
}
</script>

<style scoped>
.basket-cntor {
    position: fixed;
    width: 750px;
    height: 134px;
    padding: 15px 15px 0 25px;
    left: 50%;
    bottom: 90px;
    background-image: url(~@/assets/images/bg-basket.png);
    z-index: 10;
    box-sizing: border-box;
    transform: translateX(-50%);  
}

.pc .basket-cntor{
    margin-left: -7px;
}

.cntor-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #d4a161;
}

.cntor-wrapper{
    position: relative;
}

.basket-cntor .total {
    position: relative;
    padding-left:60px;
}

.basket-cntor .check-box {
    position: absolute;
    left: 0;
    top: 50%;
    width: 65px;
    height: 61px;
    background-size: 40px auto;
    background-image: url(~@/assets/images/icon-off.png);
    background-position: center;
    background-repeat: no-repeat;
    transform: translateY(-50%);
}

.basket-cntor .check-box.act {
    width: 65px;
    height: 61px;
    background-size: 65px 61px;
    background-image: url(~@/assets/images/btn-basket-all-act.png);
}

.basket-cntor .total p {
    display: inline-block;
}

.basket-cntor .sale-detail {
    display: inline-block;
    width: 148px;
    height: 38px;
    margin-top: -3px;
    margin-left: 20px;    
    color: transparent;
    font-size: 0;
    background-image: url(~@/assets/images/tag-down.png);
    vertical-align: middle;
}

.basket-cntor .u-btn.primary {
    position: relative;
    top: 20px;    
    width: 181px;
    height: 108px;
    background-image: url(~@/assets/images/btn-buy.png);
}
</style>


// WEBPACK FOOTER //
// src/components/calculator.vue